import { useState, useEffect } from "react";

// Custom hook to check for mobile device with debounced resize handling
const useIsMobile = (maxMobileWidth = 900) => {
  // Must match the server render (undefined) to avoid hydration mismatch;
  // the real value is set in the effect below.
  const [isMobile, setIsMobile] = useState(undefined);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= maxMobileWidth);
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, [maxMobileWidth]);

  return isMobile;
};

// Hook to get window size efficiently
export function useWindowSize() {
  // Same value as the server render to avoid hydration mismatch.
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    let timeoutId;
    setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    
    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }, 200); // Debounce to reduce excessive updates
    };

    window.addEventListener("resize", handleResize);
    
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return windowSize;
}

export default useIsMobile;

